import { render, staticRenderFns } from "./AssignmentToolbar.vue?vue&type=template&id=0ace4bc4&scoped=true&"
import script from "./AssignmentToolbar.vue?vue&type=script&lang=js&"
export * from "./AssignmentToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentToolbar.vue?vue&type=style&index=0&id=0ace4bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace4bc4",
  null
  
)

export default component.exports